module.exports = __webpack_public_path__ + "img/link.ab7d50a6.svg";